import { w as p, s as u, p as y, r as E } from "./useAccount-9a3d6a50.js";
import { q as Ie, u as Le } from "./useAccount-9a3d6a50.js";
import { useRef as I, useState as c, useEffect as g, useCallback as d } from "react";
import { i as b } from "./useContentfulImage-2de5e9b4.js";
import { h as Ce, a as Oe, b as ve, c as ke, d as Te, g as ze, e as Me, f as be, u as De } from "./useContentfulImage-2de5e9b4.js";
import "./myasurion-shared.mixpanel.es.js";
import { u as Fe } from "./TranslationContext-f3729120.js";
import { a as D } from "./contentful-c6e0c83f.js";
import "./lodash-3345fe65.js";
import "./domains-6461a203.js";
import "./FeatureProvider-eea49aec.js";
import "./jsx-runtime-721af1ab.js";
import "@tanstack/react-query";
import "mixpanel-browser";
import "./chunk-KRPLQIP4-1ae0870d.js";
import "@emotion/react";
import "@emotion/styled";
import "./myasurion-shared.carrier.es.js";
function V() {
  const e = I(!0);
  return e.current ? (e.current = !1, !0) : e.current;
}
function F(e) {
  const t = (s) => typeof window < "u" ? window.matchMedia(s).matches : !1, [r, o] = c(t(e));
  function a() {
    o(t(e));
  }
  return g(() => {
    const s = window.matchMedia(e);
    return a(), s.addListener ? s.addListener(a) : s.addEventListener("change", a), () => {
      s.removeListener ? s.removeListener(a) : s.removeEventListener("change", a);
    };
  }, [e]), r;
}
function N(e, t) {
  const r = V();
  g(() => {
    if (!r)
      return e();
  }, t);
}
const R = (e) => {
  p(() => {
    window.document.title = e;
  }, [e]);
}, J = "(prefers-color-scheme: dark)", ee = (e) => {
  const t = F(J), [r, o] = b(
    "usehooks-ts-dark-mode",
    e ?? t ?? !1
  );
  return N(() => {
    o(t);
  }, [t]), {
    isDarkMode: r,
    toggle: () => o((a) => !a),
    enable: () => o(!0),
    disable: () => o(!1)
  };
};
function te() {
  const [e, t] = c(null), [r, o] = c({
    width: 0,
    height: 0
  }), a = d(() => {
    o({
      width: (e == null ? void 0 : e.offsetWidth) || 0,
      height: (e == null ? void 0 : e.offsetHeight) || 0
    });
  }, [e == null ? void 0 : e.offsetHeight, e == null ? void 0 : e.offsetWidth]);
  return u("resize", a), p(() => {
    a();
  }, [e == null ? void 0 : e.offsetHeight, e == null ? void 0 : e.offsetWidth]), [t, r];
}
const ne = () => {
  const [e, t] = c(!1);
  return { handleImageOnLoad: () => {
    t(!0);
  }, css: {
    // Thumbnail style.
    thumbnail: {
      visibility: e ? "hidden" : "visible",
      filter: "blur(8px)",
      transition: "visibility 0ms ease-out 500ms"
    },
    // Full image style.
    fullSize: {
      opacity: e ? 1 : 0,
      transition: "opacity 500ms ease-in 0ms"
    }
  } };
}, re = (e, { threshold: t = 0, root: r = null, rootMargin: o = "0%", freezeOnceVisible: a = !1 }) => {
  const [s, n] = c(), i = (s == null ? void 0 : s.isIntersecting) && a, w = ([S]) => {
    n(S);
  };
  return g(() => {
    const S = e == null ? void 0 : e.current;
    if (!!!window.IntersectionObserver || i || !S)
      return;
    const C = { threshold: t, root: r, rootMargin: o }, L = new IntersectionObserver(w, C);
    return L.observe(S), () => L.disconnect();
  }, [e == null ? void 0 : e.current, JSON.stringify(t), r, o, i]), s;
}, se = (e, t) => {
  const r = I(e);
  p(() => {
    r.current = e;
  }, [e]), g(() => {
    if (!t && t !== 0)
      return;
    const o = setInterval(() => r.current(), t);
    return () => clearInterval(o);
  }, [t]);
}, oe = () => {
  const e = I(!0);
  return e.current ? (e.current = !1, !0) : e.current;
}, ie = () => {
  const e = I(!1);
  return g(() => (e.current = !0, () => {
    e.current = !1;
  }), []), d(() => e.current, []);
}, ae = (e, t) => {
  const r = d(() => {
    if (typeof window > "u")
      return t;
    try {
      const i = window.localStorage.getItem(e);
      return i ? y(i) : t;
    } catch (i) {
      return console.warn(`Error reading localStorage key “${e}”:`, i), t;
    }
  }, [t, e]), [o, a] = c(r), s = E((i) => {
    typeof window > "u" && console.warn(
      `Tried setting localStorage key “${e}” even though environment is not a client`
    );
    try {
      const w = i instanceof Function ? i(o) : i;
      window.localStorage.setItem(e, JSON.stringify(w)), a(w), window.dispatchEvent(new Event("local-storage"));
    } catch (w) {
      console.warn(`Error setting localStorage key “${e}”:`, w);
    }
  });
  g(() => {
    a(r());
  }, []);
  const n = d(
    (i) => {
      i != null && i.key && i.key !== e || a(r());
    },
    [e, r]
  );
  return u("storage", n), u("local-storage", n), [o, s];
}, ce = (e) => {
  const t = (s) => typeof window < "u" ? window.matchMedia(s).matches : !1, [r, o] = c(t(e));
  function a() {
    o(t(e));
  }
  return g(() => {
    const s = window.matchMedia(e);
    return a(), s.addListener ? s.addListener(a) : s.addEventListener("change", a), () => {
      s.removeListener ? s.removeListener(a) : s.removeEventListener("change", a);
    };
  }, [e]), r;
}, ue = (e) => {
  const t = d(() => {
    if (typeof window > "u")
      return null;
    try {
      const s = window.localStorage.getItem(e);
      return s ? JSON.parse(s) : null;
    } catch (s) {
      return console.warn(`Error reading localStorage key “${e}”:`, s), null;
    }
  }, [e]), [r, o] = c(t);
  g(() => {
    o(t());
  }, []);
  const a = d(
    (s) => {
      s != null && s.key && s.key !== e || o(t());
    },
    [e, t]
  );
  return u("storage", a), u("local-storage", a), r;
}, de = () => {
  const e = () => {
    if (typeof window < "u" && window.screen)
      return window.screen;
  }, [t, r] = c(e());
  function o() {
    r(e());
  }
  return u("resize", o), p(() => {
    o();
  }, []), t;
}, ge = (e, t) => {
  const r = I(e);
  p(() => {
    r.current = e;
  }, [e]), g(() => {
    if (!t && t !== 0)
      return;
    const o = setTimeout(() => r.current(), t);
    return () => clearTimeout(o);
  }, [t]);
}, we = (e) => {
  const [t, r] = c(!!e), o = d(() => r((a) => !a), []);
  return [t, o, r];
}, fe = () => {
  const [e, t] = c({
    width: 0,
    height: 0
  }), r = () => {
    t({
      width: window.innerWidth,
      height: window.innerHeight
    });
  };
  return u("resize", r), p(() => {
    r();
  }, []), e;
}, f = "initializeData", v = "session-storage", le = (e) => {
  const t = d(() => {
    if (typeof window > "u")
      return e;
    try {
      const n = window.sessionStorage.getItem(f);
      return n ? y(n) : e;
    } catch (n) {
      return console.warn(`Error reading service request data “${f}”:`, n), e;
    }
  }, [e, f]), [r, o] = c(t), a = E((n) => {
    typeof window > "u" && console.warn(
      `Tried setting service request data “${f}” even though environment is not a client`
    );
    try {
      const i = n instanceof Function ? n(r) : n;
      window.sessionStorage.setItem(f, JSON.stringify(i)), o(i), window.dispatchEvent(new Event(v));
    } catch (i) {
      console.warn(`Error setting service request data key “${f}”:`, i);
    }
  });
  g(() => {
    o(t());
  }, []);
  const s = d(
    (n) => {
      n != null && n.key && n.key !== f || o(t());
    },
    [f, t]
  );
  return u("storage", s), u(v, s), [r, a];
}, l = "interactionData", k = "session-storage", he = (e) => {
  const t = d(() => {
    if (typeof window > "u")
      return e;
    try {
      const n = window.sessionStorage.getItem(l);
      return n ? y(n) : e;
    } catch (n) {
      return console.warn(`Error reading service request data “${l}”:`, n), e;
    }
  }, [e, l]), [r, o] = c(t), a = E((n) => {
    typeof window > "u" && console.warn(
      `Tried setting service request data “${l}” even though environment is not a client`
    );
    try {
      const i = n instanceof Function ? n(r) : n;
      window.sessionStorage.setItem(l, JSON.stringify(i)), o(i), window.dispatchEvent(new Event(k));
    } catch (i) {
      console.warn(`Error setting service request data key “${l}”:`, i);
    }
  });
  g(() => {
    o(t());
  }, []);
  const s = d(
    (n) => {
      n != null && n.key && n.key !== l || o(t());
    },
    [l, t]
  );
  return u("storage", s), u(k, s), [r, a];
}, h = "agreementData", T = "session-storage", me = (e) => {
  const t = d(() => {
    if (typeof window > "u")
      return e;
    try {
      const n = window.sessionStorage.getItem(h);
      return n ? y(n) : e;
    } catch (n) {
      return console.warn(`Error reading service request data “${h}”:`, n), e;
    }
  }, [e, h]), [r, o] = c(t), a = E((n) => {
    typeof window > "u" && console.warn(
      `Tried setting service request data “${h}” even though environment is not a client`
    );
    try {
      const i = n instanceof Function ? n(r) : n;
      window.sessionStorage.setItem(h, JSON.stringify(i)), o(i), window.dispatchEvent(new Event(T));
    } catch (i) {
      console.warn(`Error setting service request data key “${h}”:`, i);
    }
  });
  g(() => {
    o(t());
  }, []);
  const s = d(
    (n) => {
      n != null && n.key && n.key !== h || o(t());
    },
    [h, t]
  );
  return u("storage", s), u(T, s), [r, a];
}, m = "determineIncidentData", z = "session-storage", Se = (e) => {
  const t = d(() => {
    if (typeof window > "u")
      return e;
    try {
      const n = window.sessionStorage.getItem(m);
      return n ? y(n) : e;
    } catch (n) {
      return console.warn(`Error reading service request data “${m}”:`, n), e;
    }
  }, [e, m]), [r, o] = c(t), a = E((n) => {
    typeof window > "u" && console.warn(
      `Tried setting service request data “${m}” even though environment is not a client`
    );
    try {
      const i = n instanceof Function ? n(r) : n;
      window.sessionStorage.setItem(m, JSON.stringify(i)), o(i), window.dispatchEvent(new Event(z));
    } catch (i) {
      console.warn(`Error setting service request data key “${m}”:`, i);
    }
  });
  g(() => {
    o(t());
  }, []);
  const s = d(
    (n) => {
      n != null && n.key && n.key !== m || o(t());
    },
    [m, t]
  );
  return u("storage", s), u(z, s), [r, a];
}, pe = (e = {}, t = "", r = "", o = "", a = "", s = {}, n = !1) => {
  const [i, w] = c([]), [S, $] = c(!1), [C, L] = c(null), M = JSON.stringify(e);
  return g(() => {
    $(!0), (async () => {
      try {
        const O = await D(
          e,
          t,
          r,
          o,
          a,
          s,
          n
        );
        w(O);
      } catch (O) {
        L(O);
      } finally {
        $(!1);
      }
    })();
  }, [M]), {
    contentfulEntry: i,
    contentfulEntryLoading: S,
    errors: C
  };
};
export {
  Ie as useAccount,
  me as useAgreementData,
  Le as useAuthToken,
  pe as useContentfulEntry,
  Ce as useContentfulImage,
  ee as useDarkMode,
  Se as useDetermineIncidentData,
  R as useDocumentTitle,
  te as useElementSize,
  Oe as useFeatureIsOn,
  ve as useHeader,
  ne as useImageOnLoad,
  le as useInitializeData,
  he as useInteractionData,
  re as useIntersectionObserver,
  se as useInterval,
  ke as useIsDisabledFeature,
  oe as useIsFirstRender,
  ie as useIsMounted,
  ae as useLocalStorage,
  ce as useMediaQuery,
  Te as useNotifications,
  ue as useReadLocalStorage,
  de as useScreen,
  ze as useScrollBlock,
  Fe as useSessionStorage,
  Me as useSlots,
  be as useTextScript,
  De as useTextTranslation,
  ge as useTimeout,
  we as useToggle,
  fe as useWindowSize
};
